import { render, staticRenderFns } from "./MarketUpdates.vue?vue&type=template&id=4fb50699&scoped=true&"
import script from "./MarketUpdates.vue?vue&type=script&setup=true&lang=js&"
export * from "./MarketUpdates.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb50699",
  null
  
)

export default component.exports